"use strict";

exports.__esModule = true;
exports.initClientI18n = exports.getTranslations = exports.getLanguage = void 0;

var _i18nProvider = require("./i18n-provider");

var getLanguage = function getLanguage() {
  return getInitialI18n().lang || 'en';
};

exports.getLanguage = getLanguage;

var getTranslations = function getTranslations() {
  return getInitialI18n().localeData;
};

exports.getTranslations = getTranslations;

var initClientI18n = function initClientI18n() {
  return (0, _i18nProvider.initI18n)(getLanguage(), getTranslations());
};

exports.initClientI18n = initClientI18n;

function getInitialI18n() {
  return window.__INITIAL_I18N__ || {};
}